import { OsCorrespondance } from './../models/OsCorrespondance';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Type } from '../models/Type';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OsCorrespondanceService {

  constructor(public http: HttpClient) { }

  public createOsCorrespondance(osCorrespondance: OsCorrespondance){
    return this.http.post(`${environment.urlBackend}os`, osCorrespondance);
  }

  public updateOsCorrespondance(osCorrespondance: OsCorrespondance){
    return this.http.put(`${environment.urlBackend}os`, osCorrespondance);

  }

  public deleteOsCorrespondance(osCorrespondance: OsCorrespondance){
    return this.http.delete(`${environment.urlBackend}os?idOsCorrespondance=${osCorrespondance.idOsCorrespondance}`);

  }

  public getAllType(){
    return this.http.get<Type[]>(`${environment.urlBackend}type/all`);
  }
}
